import React, { FunctionComponent, ReactChild } from 'react'
import { ThemeProvider } from 'styled-components'
import useAppSelector from 'src/hooks/useAppSelector'

interface MainThemeProviderProps {
  children: ReactChild
}

const MainThemeProvider: FunctionComponent = ({
  children
}: MainThemeProviderProps) => {
  const { themeSettingData } =
    useAppSelector((state) => state['@customisation'].data) || {}
  const settings = themeSettingData?.settings
  return <ThemeProvider theme={settings}>{children}</ThemeProvider>
}

export default MainThemeProvider
